import React from 'react';

const Footer = () => <footer className="bg-white border-t border-gray-200 px-6 py-3 flex items-center justify-between">
  <p className="text-xs text-gray-400 text-center max-w-ful leading-relaxed mx-auto">
    Water Network Analysis, a platform for analyzing and visualizing spatial data for drinking water supply — OREHM, Haute Matsiatra.
    <br />
    University of Fianarantsoa &nbsp;|&nbsp; Madatlas &nbsp;|&nbsp; © {new Date().getFullYear()}
  </p>
</footer>;

export default Footer;
